import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterByProperty',
  standalone: true
})
export class SdFilterByProperty implements PipeTransform {
  transform(items: any, property: string, value: any, include: boolean): any {
    if (items) {
      if (include === true) {
        return items.filter((item: any) => {
          if (item[property]) {
            return item[property] === value;
          } else {
            return this.deepValue(item, property) === value;
          }
        });
      } else {
        return items.filter((item: any) => item[property] !== value);
      }
    } else {
      return items;
    }
  }

  deepValue(obj, path) {
    const newPath = path.split('.');
    for (const newPathElem of newPath) {
      obj = obj[newPathElem];
    }
    return obj;
  }
}
